import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';
import { runBetAction } from '../../api/betActionSafety';
import { getNetworkStatus } from '../../api/networkStatus';
// CHANGED: also import logout and sessionExpired so every session-ending path clears this slice
import { performGlobalLogout, logout, sessionExpired } from './authSlice';

const runCasinoBetAction = (userId, details, request) => {
	if (getNetworkStatus().slow) {
		const error = new Error('Network is temporarily too slow to submit a bet.');
		error.response = { data: { message: error.message, status: 'slow' } };
		return Promise.reject(error);
	}
	return runBetAction(userId, details, request, { ambiguousStatuses: [408] });
};

export const placeAndarBaharBet = createAsyncThunk(
	'bet/andarBahar',
	async ({ userId, roundId, betType, stake, selection,rate, betId }, { rejectWithValue, dispatch }) => {
		try {
			const res = await runCasinoBetAction(userId, { gameId: 5, roundId }, () => api.post('/andar-bahar/place', { userId, roundId, betType, stake ,selection,rate,betId}));
			return {
				...res.data,
				status: 'confirmed',
				apiConfirmed: true
			};
		} catch (err) {
			const errorData = err.response?.data;
			if (errorData?.duplicate) {
				return {
					...errorData,
					status: 'confirmed',
					apiConfirmed: true
				};
			}
			return rejectWithValue(err.response?.data || { message: 'Bet operation failed', status: 'rejected' });
		}
	}
);

export const placeAAABet = createAsyncThunk('bet/aaa', async ({ userId, roundId, betType, stake ,selection,rate}, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 11, roundId }, () => api.post('/aaa/place', { userId, roundId, betType, stake,selection ,rate}));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Bet failed', status: 'rejected' });
	}
});

export const placelucky = createAsyncThunk('bet/lucky7', async ({ userId, roundId, betType, stake,selection ,rate}, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 4, roundId }, () => api.post('/lucky7/place', { userId, roundId, betType, stake,selection,rate }));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Bet failed', status: 'rejected' });
	}

});

export const placedrogontiger = createAsyncThunk('bet/dragon-tiger', async ({ userId, roundId, betType, stake,marketName,selection,rate}, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 6, roundId }, () => api.post('/dragon-tiger/place', { userId, roundId, betType, stake ,marketName,selection,rate}));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Bet failed', status: 'rejected' });
	}
});

export const placedrogontigerlion = createAsyncThunk('bet/dtl', async ({ userId, roundId, betType, stake, selection ,rate}, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 7, roundId }, () => api.post('/dtl/placeBet', { userId, roundId, betType, stake ,selection,rate}));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Bet failed', status: 'rejected' });
	}
});

export const placebollywood = createAsyncThunk('bet/bollywood', async ({ userId, roundId, betType, stake, cardGuess,selection ,rate}, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 8, roundId }, () => api.post('/bollywood/place', { userId, roundId, betType, stake, cardGuess ,selection ,rate}));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Bet failed', status: 'rejected' });
	}
});

export const placebaccarat = createAsyncThunk('bet/baccarat', async ({ userId, roundId, betType, stake ,selection,rate }, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 10, roundId }, () => api.post('/baccarat/place', { userId, roundId, betType, stake ,selection,rate}));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Bet failed', status: 'rejected' });
	}
});

export const placecard32 = createAsyncThunk('bet/card-32', async ({ userId, roundId, betType, stake,selection ,rate}, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 12, roundId }, () => api.post('/card-32/place', { userId, roundId, betType, stake ,selection,rate}));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Bet failed', status: 'rejected' });
	}
});

export const placeonedaydt = createAsyncThunk('bet/oneday-dt', async ({ userId, roundId, betType, stake,selection ,rate}, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 13, roundId }, () => api.post('/oneday-dt/place', { userId, roundId, betType, stake,selection ,rate}));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Bet failed', status: 'rejected' });
	}
});

export const placeteenpatti20 = createAsyncThunk('bet/teen-patti', async ({ userId, roundId, betType, selection, stake,rate }, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 1, roundId }, () => api.post('/teen-patti/place', { userId, roundId, betType, selection, stake ,rate}));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Bet failed', status: 'rejected' });
	}
});
export const placeteenpattitwocard = createAsyncThunk('bet/two-card', async ({ userId, roundId, betType, selection, stake,rate }, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 9, roundId }, () => api.post('/two-card/place', { userId, roundId, betType, selection, stake,rate }));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Bet failed', status: 'rejected' });
	}
});

export const placeAviater = createAsyncThunk(
  'aviator/place',
  async ({ userId, roundId, stake, autoCashoutMultiplier }, { rejectWithValue }) => {
    try {
			const res = await runCasinoBetAction(userId, { gameId: 2, roundId }, () => api.post('/aviator/place', {
        userId,
        roundId,
        stake,
        autoCashoutMultiplier,
			}));
      return {
        ...res.data,
        status: 'confirmed',
        apiConfirmed: true
      };
    } catch (err) {
      const errorData = err.response?.data;
      if (errorData?.duplicate) {
        return {
          ...errorData,
          status: 'confirmed',
          apiConfirmed: true
        };
      }
      return rejectWithValue(
        err.response?.data || { message: 'Bet failed' }
      );
    }
  }
);

export const placeCashoutAviater = createAsyncThunk('aviator/cashout', async ({ userId, roundId, betId, cashoutMultiplier }, { rejectWithValue }) => {
	try {
		const res = await runCasinoBetAction(userId, { gameId: 2, roundId }, () => api.post('/aviator/cashout', { userId, roundId, betId, cashoutMultiplier }));
		return {
			...res.data,
			status: 'confirmed',
			apiConfirmed: true
		};
	} catch (err) {
		const errorData = err.response?.data;
		if (errorData?.duplicate) {
			return {
				...errorData,
				status: 'confirmed',
				apiConfirmed: true
			};
		}
		return rejectWithValue(err.response?.data || { message: 'Cashout failed', status: 'rejected' });
	}
});

export const placeBetRoualete = createAsyncThunk(
    '/roulette/placeBetRoualete',
    async ({ userId, roundId, bets }, { rejectWithValue }) => {
        try {
			const res = await runCasinoBetAction(userId, { gameId: 3, roundId }, () => api.post('/roulette/place', { userId, roundId, bets }));
            return {
                ...res.data,
                status: 'confirmed',
                apiConfirmed: true
            };
        } catch (err) {
            const data = err.response?.data;
			if (data?.status === 'unknown') return rejectWithValue(data);
            const message =
                typeof data === 'string'
                    ? data
                    : data?.message || data?.error || 'Bet failed';
            return rejectWithValue({ message });
        }
    }
);

export const casinoBetPrices = createAsyncThunk(
	'bet/casinoBetPrices',
	async ({ userId }, { rejectWithValue }) => {
		try {
			const res = await api.get(`/casino-games/bet-prices/${userId}`);
			console.log('Response:', res.data);
			return res.data;
		} catch (err) {
			return rejectWithValue(err.response?.data || { message: 'Failed to fetch bet prices' });
		}
	}
);


export const updateBetPrice = createAsyncThunk(
	'bet/updateBetPrice',
	async ({ userId, label, newValue }, { rejectWithValue }) => {
		try {
			const response = await api.put(
				`/casino-games/bet-prices/${userId}/update`,
				null,
				{
					params: {
						newValue,
						label,
					},
				}
			);
			return response.data;
		} catch (err) {
			return rejectWithValue(err.response?.data ?? err.message);
		}
	}
);


export const BetReview = createAsyncThunk(
  'bet/BetReview',
  async ({ userId, matchId,marketType = 'FANCY' }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/bets/exposure/${userId}/${matchId}`, {
        params: {
          marketType: marketType
         
        }
      });
      return res.data;
    } catch (err) {
      console.error('Exposure error:', err);
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch exposure' });
    }
  }
);

export const CasinoMyBets = createAsyncThunk(
  'bet/CasinoMyBets',
  async ({ userId, roundId }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/bets/casino/user-bets/${userId}/${roundId}`);
      return res.data;
    } catch (err) {
      console.error('Exposure error:', err);

      return rejectWithValue(
        err?.response?.data || {
          message: err.message || 'Failed to fetch exposure',
        }
      );
    }
  }
);


export const aviatoCancelButton = createAsyncThunk(
  'bet/aviatoCancelButton',
  async ({ roundId, userId }, { rejectWithValue }) => {
    try {
	const res = await runCasinoBetAction(userId, { gameId: 2, roundId }, () => api.delete(`/aviator/cancel/${roundId}/${userId}`));
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || {
          message: err.message || 'Failed to cancel bet',
        }
      );
    }
  }
);

// NEW: single reset used by every session-ending action.
// Also fixes the old typo: it reset `aviatoActionButton`, but the real key is `aviatoCancelButton`.
const resetBetState = (state) => {
    state.placing = false;
    state.lastBet = null;
    state.error = null;
    state.CasinoMyBets = { data: [], loading: false, error: null };
    state.aviator = { data: null, bets: [], cashouts: [], loading: false, error: null };
    state.aviatoCancelButton = { loading: false, data: null, error: null };
    state.Roualete = { loading: false, data: null, error: null };
    state.casinoBetPrices = { betPrices: [], BetReviewdata: [], CasinoMyBetsData: [], loading: false };
};


const betSlice = createSlice({
    name: 'bet',
    initialState: {
        placing: false, lastBet: null, error: null,
        CasinoMyBets: {         
            data: [],
            loading: false,
            error: null,
        },
        aviator: {
            data: null,
            bets: [],
            cashouts: [],
            loading: false,
            error: null,
        },
		aviatoCancelButton: {
    loading: false,
    data: null,
    error: null,
},
Roualete: {
  loading: false,
  data: null,
  error: null
},
        casinoBetPrices: {
            betPrices: [],
            BetReviewdata: [],
            CasinoMyBetsData: [],
            loading: false
        },
    },
    reducers: {
		 setBetReviewData: (state, action) => {       
      state.casinoBetPrices.BetReviewdata = action.payload;
    },
	},
    extraReducers: (builder) => {
        builder
            .addCase(placeAndarBaharBet.pending, (state) => { state.placing = true; state.error = null; })
            .addCase(placeAndarBaharBet.fulfilled, (state, action) => { state.placing = false; state.lastBet = action.payload; })
            .addCase(placeAndarBaharBet.rejected, (state, action) => { state.placing = false; state.error = action.payload?.message || 'Bet failed'; })

            .addCase(placeAAABet.pending, (state) => { state.placing = true; state.error = null; })
            .addCase(placeAAABet.fulfilled, (state, action) => { state.placing = false; state.lastBet = action.payload; })
            .addCase(placeAAABet.rejected, (state, action) => { state.placing = false; state.error = action.payload?.message || 'Bet failed'; })

            .addCase(placelucky.pending, (state) => { state.placing = true; state.error = null; })
            .addCase(placelucky.fulfilled, (state, action) => { state.placing = false; state.lastBet = action.payload; })
            .addCase(placelucky.rejected, (state, action) => { state.placing = false; state.error = action.payload?.message || 'Bet failed'; })

            .addCase(placedrogontiger.pending, (state) => { state.placing = true; state.error = null; })
            .addCase(placedrogontiger.fulfilled, (state, action) => { state.placing = false; state.lastBet = action.payload; })
            .addCase(placedrogontiger.rejected, (state, action) => { state.placing = false; state.error = action.payload?.message || 'Bet failed'; })

            .addCase(placebollywood.pending, (state) => { state.placing = true; state.error = null; })
            .addCase(placebollywood.fulfilled, (state, action) => { state.placing = false; state.lastBet = action.payload; })
            .addCase(placebollywood.rejected, (state, action) => { state.placing = false; state.error = action.payload?.message || 'Bet failed'; })

            .addCase(placebaccarat.pending, (state) => { state.placing = true; state.error = null; })
            .addCase(placebaccarat.fulfilled, (state, action) => { state.placing = false; state.lastBet = action.payload; })
            .addCase(placebaccarat.rejected, (state, action) => { state.placing = false; state.error = action.payload?.message || 'Bet failed'; })

            .addCase(placecard32.pending, (state) => { state.placing = true; state.error = null; })
            .addCase(placecard32.fulfilled, (state, action) => { state.placing = false; state.lastBet = action.payload; })
            .addCase(placecard32.rejected, (state, action) => { state.placing = false; state.error = action.payload?.message || 'Bet failed'; })

            .addCase(placeonedaydt.pending, (state) => { state.placing = true; state.error = null; })
            .addCase(placeonedaydt.fulfilled, (state, action) => { state.placing = false; state.lastBet = action.payload; })
            .addCase(placeonedaydt.rejected, (state, action) => { state.placing = false; state.error = action.payload?.message || 'Bet failed'; })

            .addCase(placeteenpatti20.pending, (state) => { state.placing = true; state.error = null; })
            .addCase(placeteenpatti20.fulfilled, (state, action) => { state.placing = false; state.lastBet = action.payload; })
            .addCase(placeteenpatti20.rejected, (state, action) => { state.placing = false; state.error = action.payload?.message || 'Bet failed'; })

            .addCase(placeteenpattitwocard.pending, (state) => { state.placing = true; state.error = null; })
            .addCase(placeteenpattitwocard.fulfilled, (state, action) => { state.placing = false; state.lastBet = action.payload; })
            .addCase(placeteenpattitwocard.rejected, (state, action) => { state.placing = false; state.error = action.payload?.message || 'Bet failed'; })

            .addCase(placeAviater.pending, (state) => {
                state.aviator.loading = true;
                state.aviator.error = null;
            })
            .addCase(placeAviater.fulfilled, (state, action) => {
                state.aviator.loading = false;
                state.aviator.data = action.payload;

                const newBet = {
                    ...action.payload,
                    roundId: action.payload.roundId || null,
                    status: action.payload.status || 'confirmed',
                    apiConfirmed: action.payload.apiConfirmed || true,
                    timestamp: action.meta.requestId
                };
                
                const existingIndex = state.aviator.bets.findIndex(b => b.betId === newBet.betId);
                if (existingIndex !== -1) {
                    state.aviator.bets[existingIndex] = newBet;
                } else {
                    state.aviator.bets.push(newBet);
                }
            })
            .addCase(placeAviater.rejected, (state, action) => {
                state.aviator.loading = false;
                state.aviator.error = action.payload?.message || 'Bet failed';
            })

            .addCase(placeCashoutAviater.pending, (state) => {
                state.aviator.loading = true;
                state.aviator.error = null;
            })
            .addCase(placeCashoutAviater.fulfilled, (state, action) => {
                state.aviator.loading = false;
                
                if (!state.aviator.cashouts) {
                    state.aviator.cashouts = [];
                }
                
                state.aviator.cashouts.push(action.payload);     
                
              
                if (action.payload?.roundId) {
                    const bet = state.aviator.bets?.find(b => b.roundId === action.payload.roundId);
                    if (bet) {
                        bet.cashedOut = true;
                        bet.cashoutMultiplier = action.payload.cashoutMultiplier;
                        bet.cashoutAmount = action.payload.amount || (bet.stake * action.payload.cashoutMultiplier);
                    }
                }
            })
            .addCase(placeCashoutAviater.rejected, (state, action) => {
                state.aviator.loading = false;
                state.aviator.error = action.payload?.message || action.payload || 'Cashout failed';
            })

              .addCase(placeBetRoualete.pending, (state) => {
                  state.Roualete.loading = true;
                  state.Roualete.error = null;
              })
              .addCase(placeBetRoualete.fulfilled, (state, action) => {
                  state.Roualete.loading = false;
                  state.Roualete.data = action.payload;
              })
              .addCase(placeBetRoualete.rejected, (state, action) => {
                  state.Roualete.loading = false;
                  state.Roualete.error = action.payload?.message || 'Bet failed';
              })

            // CHANGED: every path that ends a session clears this slice
            .addCase(performGlobalLogout.fulfilled, resetBetState)
            .addCase(logout, resetBetState)
            .addCase(sessionExpired, resetBetState);
    }
});
export const { setBetReviewData } = betSlice.actions;
export default betSlice.reducer;